import React from 'react';

import { PetDemographicsPetCard } from './PetDemographicsPetCard';
import { formatShortDateByLanguage } from '../../services/language.utils';

import styles from './CompletePetDetails.module.css';

const CompletePetDetailsPetList = ({
  getOriginalPetName = () => '',
  isPetDetailsComplete = () => false,
  isPostSubmissionMode = false,
  isReplaced = () => false,
  isRolloverCard = false,
  onCancelReplacement = () => { },
  onConfirmReplacement = () => { },
  onReplaceSubmit = () => { },
  onUndoReplace = () => { },
  onUpdatePetDemographics = () => { },
  pets = [],
}) => {
  const handleUpdate = (updatedDetails, index) => {
    onUpdatePetDemographics(updatedDetails, index);
  };

  return (
    <div className={styles.petCardList}>
      {pets.map(({ index, pet }) => {
        const { demographicData } = pet;
        const isCompleted = isPetDetailsComplete(demographicData);
        const isReadOnly = isPostSubmissionMode && !!pet.isFromSubmission;

        return (
          <PetDemographicsPetCard
            key={demographicData.petName || index}
            age={demographicData.age}
            breed={demographicData.breed}
            breedId={demographicData.breedId}
            coverageEffectiveDate={formatShortDateByLanguage(
              pet.coverageStartDate,
            )}
            currentPet={isRolloverCard ? pet : null}
            dateOfBirth={demographicData.dateOfBirth}
            isCompleted={isCompleted}
            isReadOnly={isReadOnly}
            isReplaced={isReplaced(index)}
            isRolloverPet={isRolloverCard}
            onCancelReplacement={onCancelReplacement}
            onConfirmReplacement={onConfirmReplacement}
            onReplaceSubmit={onReplaceSubmit}
            onUndoReplace={onUndoReplace}
            originalPetName={getOriginalPetName(index)}
            petName={demographicData.petName}
            petNumber={index}
            specie={demographicData.species}
            updateDemographics={handleUpdate}
            weight={demographicData.weight}
          />
        );
      })}
    </div>
  );
};

export { CompletePetDetailsPetList };
